class ConflictResolver {
  // ##### STRATEGIES
  STRATEGIES = {
    LAST_WRITE_WINS: 'last-write-wins',
    SERVER_WINS: 'server-wins',
    CLIENT_WINS: 'client-wins'
  };

  // ##### DETECT CONFLICT - Compare timestamps
  detectConflict(localItem, serverItem) {
    if (!localItem || !serverItem) return false;
    if (!localItem.updated_at || !serverItem.updated_at) return false;
    
    const localTime = new Date(localItem.updated_at).getTime();
    const serverTime = new Date(serverItem.updated_at).getTime();
    
    return serverTime > localTime;
  }

  // ##### RESOLVE CONFLICT - Apply strategy
  resolveConflict(localItem, serverItem, strategy = this.STRATEGIES.LAST_WRITE_WINS) {
    if (!this.detectConflict(localItem, serverItem)) {
      return localItem;
    }

    switch (strategy) {
      case this.STRATEGIES.SERVER_WINS:
        return serverItem;
      
      case this.STRATEGIES.CLIENT_WINS:
        return localItem;
      
      case this.STRATEGIES.LAST_WRITE_WINS:
      default:
        const localTime = new Date(localItem.local_updated_at || localItem.updated_at).getTime();
        const serverTime = new Date(serverItem.updated_at).getTime();
        return serverTime > localTime ? serverItem : localItem;
    }
  }

  // ##### SHOULD RESOLVE CONFLICT - Check if needs resolution
  shouldResolveConflict(localUpdatedAt, serverUpdatedAt) {
    if (!localUpdatedAt || !serverUpdatedAt) return false;
    return new Date(serverUpdatedAt).getTime() > new Date(localUpdatedAt).getTime();
  }
}

export const conflictResolver = new ConflictResolver();
export default conflictResolver;
